import {
    formatOrganizationCode,
    formatOrganizationCodeWithCaret,
    normalizeOrganizationCode
} from "./organizationCodeFormatter";

/**
 * Base pour les formulaires
 * Le store associé au formulaire doit implémenter la méthode getResolverOrganizationData pour exploiter ce mixin
 * @param ctx
 * @returns {(*&{readonly hasCodeServerValidationFeedback: boolean, readonly getCodeServerValidationFeedback: (string|string)})|string|boolean}
 */
export function withOrganizationCodeFeedback(ctx) {

        ctx.hasCodeServerValidationFeedback = function () {
            const store = this.store;
            if (!store) return false;

            const state = this.store.getFieldState('organizationCode');
         //   console.log('hasCodeServerValidationFeedback', state);
            return state?.server?.status !== 'idle';
        }
        ctx.getCodeServerValidationFeedbackClass = function () {
            const store = this.store;
            if (!store) return false;

            const state = this.store.getFieldState('organizationCode');
            //   console.log('hasCodeServerValidationFeedback', state);
            return state?.server?.status === 'error' ? 'error' : '';
        },

        ctx.getCodeServerValidationFeedback = function() {
          //  console.log('getCodeServerValidationFeedback');
            const store = this.store;
            if (!store) return false;
            const fieldState = store.getFieldState('organizationCode');
            if (!fieldState) return '';

            const codeType = fieldState.meta?.type ?? '';

            if (fieldState.server?.status === 'pending') {
                return "Vérification de l'existence du code...";
            }

            if (fieldState.server?.status === 'success') {
                let nameInfo = store.getResolverOrganizationData()?.name ?? '';

                if (nameInfo !== '') {
                    nameInfo = ", correspond à " + nameInfo;
                }

                return `Code ${codeType} vérifié dans la base officielle${nameInfo}`;
            }

            if (fieldState.server?.status === 'not-found') {
                return `Le code ${codeType} fourni n'a pas été trouvé dans la base officielle`;
            }
            if (fieldState.server?.status === 'server-error') {
                return `Une erreur s'est produite lors de l'interrogation de la base officielle, veuillez réessayer ou vous inscrire sans numéro d'organisation pour l'instant`;
            }
            if (fieldState.server?.status === 'client-error') {
                return `Une erreur s'est produite lors de la vérification du code organisation, veuillez réessayer ou vous inscrire sans numéro d'organisation pour l'instant`;
            }

            return '';
        }
        ctx.initOrganizationCodeField = function(el) {

            const raw =
                this.store.values.organizationCode ?? ''

            el.value = formatOrganizationCode(raw)
        }

        ctx.onOrganizationCodeInput = function(event) {

            const input = event.target

            const result = formatOrganizationCodeWithCaret(
                input.value,
                input.selectionStart
            )

            /**
             * Mise à jour visuelle immédiate
             */
            input.value = result.formatted

            /**
             * Synchronisation valeur métier
             */
            this.store.setField(
                'organizationCode',
                result.raw
            )

            /**
             * Restauration caret
             *
             * requestAnimationFrame évite certains glitches
             * Safari/mobile.
             */
            requestAnimationFrame(() => {

                input.setSelectionRange(
                    result.caret,
                    result.caret
                )

            })

        }

    return ctx;
}
